var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Menu',{ref:"leftMenu",attrs:{"open-names":_vm.openNames,"active-name":_vm.activeName},on:{"on-select":_vm.selectMenuNav}},[_c('sub-menu',{attrs:{"subMenuDate":_vm.menuData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }